import Api from '../../api/index'

const globalVariable = {
  state: {
    currpath: '',
    selfAreaId: '',
    selfAddress: '',
    siteMessage: [],
    nationalArea: [],
    brands: [],
    dispatcherList: [], // 全量调度员
    replyTypeList: [], // 违规类型
    tableDataBrands: [], // 品牌
    ratioSites: [] // 当前任务满桩值的站点列表
  },

  mutations: {
    setHistory: (state, data) => {
      state.currpath = data
    },
    setAreaId: (state, data) => {
      state.selfAreaId = data
    },
    selfAddress: (state, data) => {
      state.selfAddress = data
    },
    tableDataBrands: (state, data) => {
      state.tableDataBrands = data
    },
    save: (state, data) => {
      state[data.key] = data.value
    }
  },

  actions: {
    getCompany({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Api.getEnterpriseList(payload)
          .then(res => {
            if (res.code === 200) {
              // console.log('tableDataBrands', res.data.lists)
              commit('save', {
                key: 'tableDataBrands',
                value: res.data.lists
              })
            } else {
              console.log('getCompany数据拉取失败', res)
              reject(res)
            }
          })
          .catch(err => {
            console.log('getCompany数据接口报错', err)
            reject(err)
          })
      })
    },
    logout({ commit }) {
      commit('setHistory', '')
      commit('setAreaId', '')
      commit('selfAddress', '')
      commit('tableDataBrands', [])
    },
    getNationalArea({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Api.getNationalArea(payload)
          .then(res => {
            if (res.code === 200) {
              commit('save', {
                key: 'nationalArea',
                value: res.data
              })
              resolve(res)
            } else {
              console.log('全国地址失败', res)
              reject(res)
            }
          })
          .catch(err => {
            console.log('全国地址接口报错', err)
            reject(err)
          })
      })
    },
    activeSave({ commit }, data) {
      commit('save', data)
    }
  }
}

export default globalVariable
